import _get from 'lodash/get';

import { createReducer } from 'utils/reducer';
import { createSelector } from 'reselect';
import * as uiActions from './actions';

import * as helpers from './reducerHelpers';
import * as authActions from '../../auth/actions';

const INITIAL_STATE = {
    isPackagingEnabled: false,
};

const featureFlags = {
    [authActions.logout.SUCCESS]: helpers.logoutSuccess,
    [uiActions.setFeatureFlag.SUCCESS]: helpers.setFeatureFlagSuccess,
};

export default createReducer(INITIAL_STATE, featureFlags);

/**
 * Get state of the FeatureFlags store
 *
 * @method getFeatureFlag
 * @param  {Object}      state The current state
 * @return {Object}            The Feature Flags state
 */
export const getFeatureFlags = state => _get(state, 'ui.featureFlags', {});

/**
 * Get the isPackagingEnabled status
 *
 * @method isPackagingEnabled
 * @param  {Object}     state
 * @return {boolean}
 */
export const isPackagingEnabled = createSelector([getFeatureFlags], featureFlag =>
    _get(featureFlag, 'isPackagingEnabled', false)
);
